import React, { useState } from 'react';
import { 
  Scale, 
  FileText, 
  Download, 
  Copy, 
  CheckCircle2, 
  Building2,
  Info
} from 'lucide-react';

export const OaicComplaintGeneratorPage: React.FC = () => {
  const [breachedCompany, setBreachedCompany] = useState('Latitude Financial Services');
  const [victimName, setVictimName] = useState('Alex Mitchell');
  const [incidentDate, setIncidentDate] = useState('2026-03-14');

  const complaintText = `OFFICE OF THE AUSTRALIAN INFORMATION COMMISSIONER (OAIC)
FORMAL COMPLAINT UNDER SECTION 36 OF THE PRIVACY ACT 1988 (CTH)

COMPLAINANT: ${victimName}
RESPONDENT ENTITY: ${breachedCompany}
DATE: ${new Date().toLocaleDateString('en-AU')}

1. GROUNDS OF COMPLAINT
I hereby lodge a formal complaint against ${breachedCompany} for serious interference with my privacy under Section 13 of the Privacy Act 1988 (Cth), specifically breaching Australian Privacy Principle 11 (Security of Personal Information).

2. PARTICULARS OF INTERFERENCE
On or around ${incidentDate}, personal identity documents and credentials held by ${breachedCompany} were exfiltrated by unauthorized third parties due to unreasonable failures in technical access controls.

3. HARM & REMEDIES SOUGHT
As a direct consequence of this eligible data breach, I have suffered emotional distress, heightened identity theft risk, and direct costs associated with document replacement and credit file suppression.

I formally request the Information Commissioner investigate this interference and make a declaration under Section 52 of the Act ordering ${breachedCompany} to reimburse direct replacement costs and provide compensation for non-economic loss.

Signed: ${victimName}`;

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10 space-y-8">
      <div className="text-center space-y-2">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-emerald-950 text-emerald-300 text-xs font-bold border border-emerald-800">
          <Scale className="w-3.5 h-3.5" />
          <span>OAIC PRIVACY ACT 1988 SECTION 36 GENERATOR</span>
        </div>
        <h1 className="text-3xl font-extrabold text-white">Australian Privacy Commissioner (OAIC) Complaint Generator</h1>
        <p className="text-xs text-slate-400 max-w-xl mx-auto">
          Generate an official legal complaint letter to the Privacy Commissioner seeking investigation and compensation following a corporate data breach.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 text-xs">
        <div className="lg:col-span-5 bg-slate-900 border border-slate-800 rounded-3xl p-6 space-y-4 shadow-xl">
          <h3 className="font-bold text-white text-sm">Complaint Parameters:</h3>
          <div>
            <label className="block text-slate-300 mb-1">Breached Organisation Name:</label>
            <input
              type="text"
              value={breachedCompany}
              onChange={(e) => setBreachedCompany(e.target.value)}
              className="w-full px-3 py-2 rounded-xl bg-slate-950 border border-slate-700 text-white"
            />
          </div>
          <div>
            <label className="block text-slate-300 mb-1">Your Full Name:</label>
            <input
              type="text"
              value={victimName}
              onChange={(e) => setVictimName(e.target.value)}
              className="w-full px-3 py-2 rounded-xl bg-slate-950 border border-slate-700 text-white"
            />
          </div>
        </div>

        <div className="lg:col-span-7 bg-slate-900 border border-slate-800 rounded-3xl p-6 space-y-3 shadow-xl">
          <textarea
            readOnly
            rows={12}
            value={complaintText}
            className="w-full p-4 rounded-xl bg-slate-950 border border-slate-800 text-slate-300 font-mono text-[11px] leading-relaxed resize-none focus:outline-none"
          />
        </div>
      </div>
    </div>
  );
};
